const getObjectsFromCache = (cache, typename, ids) => {
  const cachedObjects = ids.map((askedId) => cache.data.data[`${typename}:${askedId}`]);
  return cachedObjects.filter((obj) => !!obj);
};

export default getObjectsFromCache;
